export default [

    // *===============================================---*
    // *--------- Email - Marketing  ---------------------------------------*
    // *===============================================---*
    {
        path: '/email/list',
        name: 'email-list',
        component: () => import('@/views/marketing/email/list.vue'),
        meta: {
            pageTitle: 'Marketing Settings',
            breadcrumb: [
                {
                    text: 'Marketing Settings',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    

    {
        path: '/email/add',
        name: 'email-add-campaign',
        component: () => import('@/views/marketing/email/AddCampaigne.vue'),
        meta: {
            pageTitle: 'Marketing Setting',
            breadcrumb: [
                {
                    text: 'Marketing Setting',
                    to: '/email/list',
                },
                {
                    text: 'Marketing Setting',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    {
        path: '/email/edit/:id',
        name: 'email-edit-campaign',
        component: () => import('@/views/marketing/email/EditCampaigne.vue'),
        meta: {
            pageTitle: 'Edit Campaign',
            breadcrumb: [
                {
                    text: 'Marketing Email Campaign List',
                    to: '/email/list',
                },
                {
                    text: 'Edit Campaign',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    {
        path: '/email/view/:id',
        name: 'email-view-campaign',
        component: () => import('@/views/marketing/email/ViewCampaigne.vue'),
        meta: {
            pageTitle: 'View Campaign',
            breadcrumb: [
                {
                    text: 'Marketing Email Campaign List',
                    to: '/email/list',
                },
                {
                    text: 'View Campaign',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },


    {
        path: '/marketing/segment/:id',
        name: 'email-segment-customers',
        component: () => import('@/views/marketing/email/ViewCustomerSegment.vue'),
        meta: {
            pageTitle: 'View Customer Segment',
            breadcrumb: [
                {
                    text: 'View Segments',
                    to: '/email/list',
                },
                {
                    text: 'View Customer Segment',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },


]